"use strict";
'use es6'; // Only for properties that won't change

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var TermIds = _interopRequireWildcard(require("self-service-api/constants/TermIds"));

var _TermIds$MONTHLY_NO_D;

var _default = (_TermIds$MONTHLY_NO_D = {}, (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_NO_DISCOUNT, {
  trackingName: 'Monthly No Discount',
  discountPercent: 0,
  commitmentLength: 'monthly'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_20_PERCENT_DISCOUNT, {
  trackingName: 'Monthly 20% Discount',
  discountPercent: 0.2,
  commitmentLength: 'monthly'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_25_PERCENT_DISCOUNT, {
  trackingName: 'Monthly 25% Discount',
  discountPercent: 0.25,
  commitmentLength: 'monthly'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_50_PERCENT_DISCOUNT, {
  trackingName: 'Monthly 50% Discount',
  discountPercent: 0.5,
  commitmentLength: 'monthly'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_30_PERCENT_DISCOUNT, {
  trackingName: 'Monthly 30% Discount',
  discountPercent: 0.3,
  commitmentLength: 'monthly'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_NO_DISCOUNT, {
  trackingName: 'Annual No Discount',
  discountPercent: 0,
  commitmentLength: 'annual'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_20_PERCENT_DISCOUNT, {
  trackingName: 'Annual 20% Discount',
  discountPercent: 0.2,
  commitmentLength: 'annual'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_25_PERCENT_DISCOUNT, {
  trackingName: 'Annual 25% Discount',
  discountPercent: 0.25,
  commitmentLength: 'annual'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.HSFS_50_PERCENT_DISCOUNT, {
  trackingName: 'HSFS 50% Discount',
  discountPercent: 0.5,
  commitmentLength: 'monthly'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.HSFX_ENTREPRENEUR_DISCOUNT, {
  trackingName: 'HSFE 30% Discount',
  discountPercent: 0.3,
  commitmentLength: 'monthly'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.HSFX_BOOTSTRAP_DISCOUNT, {
  trackingName: 'HSFX 40% Discount',
  discountPercent: 0.4,
  commitmentLength: 'monthly'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.HSFS_90_PERCENT_DISCOUNT, {
  trackingName: 'HSFS 90% Discount',
  discountPercent: 0.9,
  commitmentLength: 'monthly'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_60_PERCENT_DISCOUNT, {
  trackingName: 'Annual 60% Discount',
  discountPercent: 0.6,
  commitmentLength: 'annual'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_50_PERCENT_DISCOUNT, {
  trackingName: 'Annual 50% Discount',
  discountPercent: 0.5,
  commitmentLength: 'annual'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_30_PERCENT_DISCOUNT, {
  trackingName: 'Annual 30% Discount',
  discountPercent: 0.3,
  commitmentLength: 'annual'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_10_PERCENT_DISCOUNT, {
  trackingName: 'Annual 10% Discount',
  discountPercent: 0.1,
  commitmentLength: 'annual'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_PLACEHOLDER, {
  trackingName: 'Monthly Placeholder',
  discountPercent: 0,
  commitmentLength: 'monthly'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_PLACEHOLDER, {
  trackingName: 'ANNUAL Placeholder',
  discountPercent: 0,
  commitmentLength: 'annual'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_BASIC_TO_PRO_DISCOUNT, {
  trackingName: 'Annual Marketing Basic to Pro Discount',
  discountPercent: 0.25,
  commitmentLength: 'annual'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_40_PERCENT_DISCOUNT, {
  trackingName: 'Monthly 40% Discount',
  discountPercent: 0.4,
  commitmentLength: 'monthly'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_40_PERCENT_DISCOUNT, {
  trackingName: 'Annual 40% Discount',
  discountPercent: 0.4,
  commitmentLength: 'annual'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.LATAM_ES_MONTHLY_40_PERCENT_DISCOUNT, {
  trackingName: 'LATAM-ES Monthly 40% Discount',
  discountPercent: 0.4,
  commitmentLength: 'monthly'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.LATAM_ES_ANNUAL_40_PERCENT_DISCOUNT, {
  trackingName: 'LATAM-ES Annual 40% Discount',
  discountPercent: 0.4,
  commitmentLength: 'annual'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.MONTHLY_PROMO_NO_DISCOUNT, {
  trackingName: 'Monthly Promotional 0% Discount',
  discountPercent: 0,
  commitmentLength: 'monthly'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.ANNUAL_PROMO_NO_DISCOUNT, {
  trackingName: 'Annual Promotional 0% Discount',
  discountPercent: 0,
  commitmentLength: 'annual'
}), (0, _defineProperty2.default)(_TermIds$MONTHLY_NO_D, TermIds.COVID_PROMO_MONTHLY_66_PERCENT_DISCOUNT, {
  trackingName: 'CoViD-19 Monthly 66% Discount',
  discountPercent: 0.666667,
  commitmentLength: 'monthly'
}), _TermIds$MONTHLY_NO_D);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/ImmutableTermIdMap.js
// module id = 310
// module chunks = 5 6 7